export type ResourceDetailViewMode = 'preview' | 'fields' | 'raw';

interface BuildResourceExplorerDetailUrlOptions {
  organizationId: string;
  resourceType: string;
  resourceId: string;
  view?: ResourceDetailViewMode;
}

export function buildResourceExplorerDetailUrl({
  organizationId,
  resourceType,
  resourceId,
  view = 'preview',
}: BuildResourceExplorerDetailUrlOptions): string {
  const params = new URLSearchParams({
    tab: 'resource-explorer',
    rtype: resourceType,
    rid: resourceId,
    rview: view,
  });

  return `/admin-v2/organization/${encodeURIComponent(organizationId)}?${params.toString()}`;
}

export function resolveResourceDetailViewMode(
  requestedMode: string | null,
  hasPreview: boolean,
): ResourceDetailViewMode {
  if (requestedMode === 'fields' || requestedMode === 'raw') {
    return requestedMode;
  }

  if (requestedMode === 'preview' && hasPreview) {
    return 'preview';
  }

  return hasPreview ? 'preview' : 'fields';
}
